export namespace VideoCustomControls {

	let setupVideoControls = () => {
		let mp4Player = document.querySelectorAll('.js-custom-video-player');

		//For Each Video player, setup our play/pause/onend events
		mp4Player.forEach((player:HTMLDivElement) => {

			let video = player.querySelector('video');
			let playButton = player.querySelector('.js-custom-video-play');
			let pauseButton = player.querySelector('.js-custom-video-pause');
			let soundButton = player.querySelector('.js-custom-sound');
			let muteButton = player.querySelector('.js-custom-mute');

			let togglePlay = () => {
				playButton.classList.toggle('hide');
				pauseButton.classList.toggle('hide');
			}
			let toggleSound = () => {
				video.muted = !video.muted;
				muteButton.classList.toggle('hide');
				soundButton.classList.toggle('hide');
			}
			playButton.addEventListener('click', () => {
				togglePlay();
				video.play();
			});

			pauseButton.addEventListener('click', () => {
				togglePlay();
				video.pause();
			});

			if ( soundButton && muteButton ){
				soundButton.addEventListener('click', () => {
					toggleSound();
				});

				muteButton.addEventListener('click', () => {
					toggleSound();
				});
			}

			video.onended = () => {
				video.currentTime = .1;
				togglePlay();
			}

			// if this is an autoplay template setup our intersection observer
			// and play the video when it comes into view
			let autoplayVideo = player.querySelector('.js-autoplay-video');

			if ( autoplayVideo ){
				// create an intersection observer
				let options = {
					root: null,
					rootMargin: "0px",
					threshold: .5
				}
				let videoInView = (entries) => {
					entries.forEach((entry) => {
						if ( entry.isIntersecting ){
							playButton.classList.add('hide');
							pauseButton.classList.remove('hide');
							entry.target.play();
						} else {
							playButton.classList.remove('hide');
							pauseButton.classList.add('hide');
							entry.target.pause();
						}
					});
				};
				let videoObserver = new IntersectionObserver(videoInView, options);
				videoObserver.observe(video);
			}
		});
	}

	export const init = () => {
		setupVideoControls();
	}
}

document.addEventListener('DOMContentLoaded', VideoCustomControls.init);
